import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CorrespondenceInterface } from '@app/core/interfaces/correspondence.interface';
import * as fromMyClaims from '@app/my-zone/pages/claims/store';
import * as fromCorrespondences from '@app/my-zone/pages/claims/store/actions/correspondences.actions';
import * as fromRoot from '@app/store/app.reducer';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'ins-mailbox-container',
    template: `
        <ins-mailbox
            [correspondences]="correspondences$ | async"
            [loaded]="loaded$ | async"
        ></ins-mailbox>
    `,
})
export class MailboxContainer implements OnInit, OnDestroy {

    @Input() file_serial_number: number;
    @Input() relation_id: number;

    public correspondences$: Observable<CorrespondenceInterface[]> = this.store
        .pipe(select(fromMyClaims.getSelectedCorrespondence), map(this.mapCorrespondenceResult));

    public loaded$: Observable<Boolean> = this.store
        .pipe(select(fromMyClaims.isCorrespondencesLoaded));

    private subscriptions: Subscription = new Subscription();

    constructor(private store: Store<fromRoot.State>) {}

    ngOnInit(): void {
        const loadedSubscription = this.loaded$
            .subscribe(
                (loaded: boolean) => {
                    if (loaded === undefined) {
                        // TODO: WINS-5572: Use service
                        this.store.dispatch(new fromCorrespondences.Load({
                            relatie_id: this.relation_id,
                            dossier_volgnummer: this.file_serial_number,
                        }));
                    }
                });
        this.subscriptions.add(loadedSubscription);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private mapCorrespondenceResult(result: CorrespondenceInterface[]): CorrespondenceInterface[] {
        let correspondences: CorrespondenceInterface[] = [];

        if (result) {
            correspondences = result.map((_result) => ({
                ..._result,
                correspondentiestuk: (_result.correspondentiestuk) ? _result.correspondentiestuk : [],
            }));
        }

        return correspondences;
    }
}
